import React from 'react'
import SvgWrapper from '../SvgWrapper'
import { ICON_SIZE, ICON_VIEWBOX } from './constants'
import type { IconProps } from './types'

const AbsencePlanIcon: React.FC<IconProps> = ({
  viewBox = ICON_VIEWBOX.medium,
  color = 'currentColor',
  size = ICON_SIZE.medium,
  isFilled,
  fillOpacity,
}) => {
  const path = isFilled ? (
    <>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="m18.71 19.403.037-.027a9.995 9.995 0 0 0 .416-.332.61.61 0 0 0 .15-.76.656.656 0 0 0-.732-.318 7.036 7.036 0 0 1-.461.096l-.03.005a7.153 7.153 0 0 1-2.62-.044 7.025 7.025 0 0 1-2.82-1.267 6.719 6.719 0 0 1-1.958-2.331c-.46-.911-.7-1.911-.7-2.925 0-1.014.24-2.014.7-2.925a6.719 6.719 0 0 1 1.959-2.331 7.023 7.023 0 0 1 2.82-1.266 7.153 7.153 0 0 1 2.62-.045l.029.005a7.163 7.163 0 0 1 .46.096c.291.07.594-.06.732-.317a.61.61 0 0 0-.148-.76 10.389 10.389 0 0 0-.416-.333l-.035-.026A10.56 10.56 0 0 0 12.362 1.5c-1.674 0-3.322.391-4.805 1.14a10.255 10.255 0 0 0-3.71 3.16 9.795 9.795 0 0 0-1.767 4.461 9.675 9.675 0 0 0 .577 4.743 9.995 9.995 0 0 0 2.79 3.944 10.486 10.486 0 0 0 4.368 2.245c1.622.397 3.32.41 4.948.035a10.525 10.525 0 0 0 3.948-1.825z"
        fill={color}
        fillOpacity={fillOpacity}
      />
      <path
        d="M12.964 10.32h1.427v1.407a.714.714 0 0 0 1.427 0V10.32h1.426c.39 0 .714-.318.714-.703a.714.714 0 0 0-.714-.703h-1.426V7.507a.714.714 0 0 0-1.427 0v1.407h-1.427a.714.714 0 0 0-.713.703c0 .385.323.703.713.703zM17.72 13.837c0 .385.323.704.713.704h.714v.703a.714.714 0 0 0 1.426 0v-.703h.714c.39 0 .713-.32.713-.704a.714.714 0 0 0-.713-.703h-.714v-.703a.714.714 0 0 0-1.426 0v.703h-.714a.714.714 0 0 0-.713.703z"
        fill={color}
        fillOpacity={fillOpacity}
      />
    </>
  ) : (
    <>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="m18.71 19.403.037-.027a9.995 9.995 0 0 0 .416-.332.61.61 0 0 0 .15-.76.656.656 0 0 0-.732-.318 7.036 7.036 0 0 1-.461.096l-.03.005a7.153 7.153 0 0 1-2.62-.044 7.025 7.025 0 0 1-2.82-1.267 6.719 6.719 0 0 1-1.958-2.331c-.46-.911-.7-1.911-.7-2.925 0-1.014.24-2.014.7-2.925a6.719 6.719 0 0 1 1.959-2.331 7.023 7.023 0 0 1 2.82-1.266 7.153 7.153 0 0 1 2.62-.045l.029.005a7.163 7.163 0 0 1 .46.096c.291.07.594-.06.732-.317a.61.61 0 0 0-.148-.76 10.389 10.389 0 0 0-.416-.333l-.035-.026A10.56 10.56 0 0 0 12.362 1.5c-1.674 0-3.322.391-4.805 1.14a10.255 10.255 0 0 0-3.71 3.16 9.795 9.795 0 0 0-1.767 4.461 9.675 9.675 0 0 0 .577 4.743 9.995 9.995 0 0 0 2.79 3.944 10.486 10.486 0 0 0 4.368 2.245c1.622.397 3.32.41 4.948.035a10.525 10.525 0 0 0 3.948-1.825zM12.363 2.929h.002a9.18 9.18 0 0 1 3.22.577 8.482 8.482 0 0 0-3.813 1.603 8.152 8.152 0 0 0-2.375 2.829 7.888 7.888 0 0 0-.853 3.562c0 1.236.292 2.454.853 3.562a8.151 8.151 0 0 0 2.376 2.83 8.482 8.482 0 0 0 3.807 1.602 9.257 9.257 0 0 1-5.415.313 9.03 9.03 0 0 1-3.761-1.933 8.567 8.567 0 0 1-2.393-3.38 8.266 8.266 0 0 1-.493-4.052A8.378 8.378 0 0 1 5.03 6.627a8.812 8.812 0 0 1 3.188-2.715 9.199 9.199 0 0 1 4.144-.983z"
        fill={color}
        fillOpacity={fillOpacity}
      />
      <path
        d="M12.964 10.32h1.427v1.407a.714.714 0 0 0 1.427 0V10.32h1.426c.39 0 .714-.318.714-.703a.714.714 0 0 0-.714-.703h-1.426V7.507a.714.714 0 0 0-1.427 0v1.407h-1.427a.714.714 0 0 0-.713.703c0 .385.323.703.713.703zM17.72 13.837c0 .385.323.704.713.704h.714v.703a.714.714 0 0 0 1.426 0v-.703h.714c.39 0 .713-.32.713-.704a.714.714 0 0 0-.713-.703h-.714v-.703a.714.714 0 0 0-1.426 0v.703h-.714a.714.714 0 0 0-.713.703z"
        fill={color}
        fillOpacity={fillOpacity}
      />
    </>
  )

  return (
    <SvgWrapper viewBox={viewBox} size={size} aria-label="absence plan icon">
      {path}
    </SvgWrapper>
  )
}

export default AbsencePlanIcon
